import { gql } from '@apollo/client';

const getPartnerByRef = gql(`query getPartner($ref: String) {
  partners(ref: $ref) {
    ref
    name 
    edrpou 
    id 
    parent 
    is_buyer 
    is_supplier
    legal_address 
    note 
    name_full 
    individual_legal 
    inn 
    isCorporate
    phones
    email
  }
}`);

const getODBPartner = gql(`query getODBPartner($edrpou: String) {
  opendatabot(kod: $edrpou)
}`);

const updatePartner = gql(`mutation updatePartner($input: JSONObject) {
  setPartner(input: $input) { _id }}`);

export { getPartnerByRef, getODBPartner, updatePartner };
